import { __decorate } from "tslib";
import { AiModel } from '../enums';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { DEFAULT_DATA_SCOPE, DEFAULT_TAGGING_SETTING, GPT_DEFAULT_DATA_SCOPE } from '../constants';
import _ from 'lodash';
let TaggingSettingModelImpl = class TaggingSettingModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = this.defaultSetting;
        // 为每个模型独立维护 dataScope，切换时从对应槽位恢复，避免两种模型共享一份配置导致字段被过滤
        this._dataScopeByModel = this.defaultDataScopeByModel;
    }
    get defaultSetting() {
        return _.clone(DEFAULT_TAGGING_SETTING);
    }
    get defaultDataScopeByModel() {
        return {
            [AiModel.PATSNAP_ML]: [...DEFAULT_DATA_SCOPE],
            [AiModel.PATSNAP_GPT]: [...GPT_DEFAULT_DATA_SCOPE],
        };
    }
    get taggingSetting() {
        return this._modelData;
    }
    updateTaggingType(taggingType) {
        this.updateData({
            taggingType,
        });
    }
    updateThreshold(threshold) {
        this.updateData({
            threshold,
        });
    }
    updateReadScope(dataScope) {
        this._dataScopeByModel[this._modelData.aiModel] = [...dataScope];
        this.updateData({
            dataScope,
        });
    }
    updateAiModel(aiModel) {
        const prevModel = this._modelData.aiModel;
        if (prevModel !== aiModel) {
            this._dataScopeByModel[prevModel] = [...(this._modelData.dataScope || [])];
        }
        this.updateData({
            aiModel,
            dataScope: [...this._dataScopeByModel[aiModel]],
        });
    }
    dispose() {
        this._dataScopeByModel = this.defaultDataScopeByModel;
        this.updateData(this.defaultSetting);
    }
    updateData(data) {
        this.update(() => {
            return {
                ...this.taggingSetting,
                ...data,
            };
        });
    }
};
TaggingSettingModelImpl = __decorate([
    injectable()
], TaggingSettingModelImpl);
export { TaggingSettingModelImpl };
